export const PLANS = {
    FREE: 'free',
    GROWTH: 'growth',
    BUSINESS: 'business',
}

export const CYCLE_TYPES = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
    ANNUALLY: 'annually',
};

export const CURRENCY_TYPES = {
    INR: 'INR',
    USD: 'USD',
};

export const CURRENCY_SYMBOLS = {
    INR: '₹',
    USD: '$',
};

export const ADD_ON_TYPES = {
    AI_CREDITS: 'AI Credits',
    REMOVE_BRANDING: 'Remove Chronox-AI branding',
};

export const PLAN_CARD_FEATURES = [
    { featureKey: 'active_contacts', showCycleSuffix: true },
    { featureKey: 'whatsapp_campaign_messages', showCycleSuffix: true },
    { featureKey: 'non_ai_voice_minutes', showCycleSuffix: true },
    { featureKey: 'users', showCycleSuffix: false },
];

export const COMPLIMENTARY_AI_CREDITS_FEATURE = 'complimentary_ai_credits';

export const POLLING_INTERVAL = 10 * 1000; // 10 seconds
export const POLLING_DURATION = 2 * 60 * 1000; // 2 minutes
